export const locale = {
  show_password: 'Show',
  hide_password: 'Hide',
  hidden: '{{label}} is hidden',
  shown: '{{label}} is shown',
  show_password_label: 'Show {{label}}',
  hide_password_label: 'Hide {{label}}',
};
